import * as React from "react";
import { Query } from "react-apollo";
import { Col } from "reactstrap";
import { TiStarOutline } from "react-icons/ti";

// GraphQL
import GetCompanyAssets from "../../../GraphQL/Queries/GetCompanyAssets";

// Presentation/UI
import Loader from "../../../Components/Loader/DotLoader";

// Theme
import { Colors } from "../../../Themes";

import styled from "@emotion/styled";

const SummaryContainer = styled.div`
  display: inline-block;
  & span {
    position: relative;
    top: 15px;
    left: 15px;
    font-size: 1.13em;
  }
  & span.summary-number {
    font-weight: 700;
    font-size: 1.73em;
  }
`;

class Assets extends React.Component<{ companyId: string }> {
  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyAssets} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the assets</div>;
          }

          const assets = data.allAssets;
          const numberOfAssets = !assets || !assets.length ? 0 : assets.length;

          return (
            <Col xs={12} md={4} lg={4}>
              <SummaryContainer>
                <TiStarOutline size="4.75em" color={Colors.cmmsBlue} />
              </SummaryContainer>
              <SummaryContainer>
                <span className="summary-number">{numberOfAssets}</span>
                <br />
                <span>Assets</span>
              </SummaryContainer>
            </Col>
          );
        }}
      </Query>
    );
  }
}

export default Assets;



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/DashboardCards/Assets.tsx